<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="mini-synopsis">
<h1>Mini Synopsis</h1>
<p><em>Skimmer – Mine</em> is the third book in a series set in 2040, about youth and their ability to adapt and cope with the situations they must face while working in the deep-sea mining industry. Ngarra’s crew have left the Chinese owned GlobeCorpMining mineral Harvester in their Skimmer and continued their mining run. The plan is to run final tests on Connor’s Xtract mining drone technology using the red queen sequence he has developed. However, concern is growing over piracy in the area. Tactics have changed and there are rumours that Skimmers are being rammed to board them. Ngarra’s crew are informed by the Xed Ocean Academy crew monitoring that the pirates may have been infiltrated by another rogue group. It appears this rogue group may be using the pirates as a cover to try and access Connor’s technology. The concern is growing over whether something has changed on the Harvester as well. Connor is convinced that someone is trying to gain access to the technology and use it in the mimic drone program Chang’s sister has developed on the Harvester for GlobeCorpMining. At the Xed Ocean Academy, Rick makes the Sea Hunters aware of the evolving situation while also convincing Jonah of the need to push ahead with the overdrive trials for the Skimmers. Meanwhile, unbeknown to Ngarra’s crew, a super-cell is developing in ‘the Area’ that inadvertently creates the opportunity the rogue group that has infiltrated the pirates have been waiting for. Isolated and alone, Ngarra’s crew must find a way to overcome the standoff and avoid capture.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch006.vue?84b54eba